module.exports = __webpack_public_path__ + "static/assets/41e973a4c18b9fc44e06b35f5dc837b6.svg";